export default {
  "m0": "Cargando datos personales…",
  "m1": "Revisa los campos indicados.",
  "m2": "Tu correo de acceso está vinculado a tu cuenta segura de socio y no puede cambiarse aquí. Contacta con el club si necesitas corregirlo.",
  "m3": "Solo para uso en emergencias por personal autorizado del club.",
  "m4": "Añadir familiar",
  "m5": "Busca un socio activo y envía una solicitud de parentesco.",
  "m6": "Socio seleccionado",
  "m7": "Familia actual",
  "m8": "No hay familiares vinculados",
  "m9": "Añade un socio arriba para iniciar una solicitud de vínculo familiar.",
  "m10": "Solicitudes recibidas",
  "m11": "Solicitudes enviadas",
  "m12": "Gestiona los vehículos asociados a tu membresía.",
  "m13": "Esta sección te permitirá:",
  "m14": "Mantén tus niveles actualizados para mejorar las partidas, los emparejamientos y las recomendaciones.",
  "m15": "Introducir hándicap exacto",
  "m16": "Usaremos estos niveles para recomendar partidas y emparejamientos adecuados.",
  "m17": "Establece un nivel arriba para iniciar tu perfil deportivo.",
  "m18": "Editar foto",
  "m19": "Retrato animado",
  "m20": "Socio n.º ",
  "m21": "Tu retrato se está preparando y aparecerá aquí automáticamente.",
  "m22": "Las imágenes se guardan de forma segura y se sincronizan con el perfil del portal del club.",
  "m23": "Volver a restauración",
  "m24": "Restauración Privana",
  "m25": "Reservas de restauración",
  "m26": "Una hospitalidad cuidada, reservada para ti.",
  "m27": "Horarios en la zona horaria de tu club",
  "m28": "Restauración Privana",
  "m29": "Planifica tu visita",
  "m30": "Buscar mesa",
  "m31": "Modificando",
  "m32": "Cargando espacios de restauración…",
  "m33": "Las reservas de restauración no están disponibles actualmente.",
  "m34": "Hora preferida · opcional",
  "m35": "Cualquier hora",
  "m36": "Buscando mesas…",
  "m37": "Tu mesa te espera",
  "m38": "Horarios disponibles",
  "m39": "Revisa tu reserva",
  "m40": "Notas y solicitudes especiales",
  "m41": "Si tienes alergias graves, contacta también directamente con el club para que el equipo de restauración pueda atenderte de forma segura.",
  "m42": "Tus planes",
  "m43": "Tu próxima mesa te espera.",
  "m44": "Elige un espacio de restauración y consulta los horarios disponibles.",
  "m45": "Hacer una reserva",
  "m46": "Las reservas no están disponibles temporalmente.",
  "m47": "Historial de reservas",
  "m48": "Aquí aparecerán tus reservas de restauración anteriores.",
  "m49": "Política de cancelación",
  "m50": "Cancelar reserva",
  "m51": "¿Cancelar la reserva de restauración?",
  "m52": "Esto libera tu mesa y está sujeto al plazo de cancelación del club. Esta acción no se puede deshacer.",
  "m53": "Mantener reserva",
  "m54": "VAMOS A JUGAR",
  "m55": "¿A qué jugamos?",
  "m56": "No se ha podido cargar Vamos a jugar en este momento.",
  "m57": "Actualmente no hay deportes disponibles en Vamos a jugar en este club.",
  "m58": "Se muestran los deportes guardados del club.",
  "m59": "Ver historial",
  "m60": "Deporte del club",
  "m61": "No hay campos de golf activos disponibles.",
  "m62": "Golf · Partida",
  "m63": "No se han podido cargar los tees de puntuación. Comprueba tu conexión o inicia sesión de nuevo y vuelve a intentarlo.",
  "m64": "Reintentar cargar tees",
  "m65": "Tees",
  "m66": "Este campo aún no está listo para Vamos a jugar.",
  "m67": "El club debe configurar sus tees de puntuación antes de que se pueda iniciar una ronda.",
  "m68": "Elegir jugadores",
  "m69": "Golf · Jugadores",
  "m70": "Aquí aparecerán los jugadores de las rondas de golf completadas en Vamos a jugar.",
  "m71": "Revisar ronda",
  "m72": "Continuar ronda",
  "m73": "No se han podido cargar tus rondas activas.",
  "m74": "hoyos completados",
  "m75": "¿Eliminar esta ronda?",
  "m76": "No se ha podido eliminar esta ronda. Inténtalo de nuevo.",
  "m77": "Actividad no disponible"
}
